export const downloadImage = async (url, name) => {
    try {
    const response = await fetch(url);
    const blob = await response.blob();

    if (!name) {
      const urlPath = new URL(url).pathname;
      const fullFilename = urlPath.split('/').pop(); // Get full filename with extension

      if (fullFilename && fullFilename.includes('.')) {
        name = fullFilename;
      } else {
        name = "image.jpg"; // Fallback if extraction fails
      }
    }

    // Create temporary download link
    const blobUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.download = name;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);

    // Cleanup
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Failed to download image:', error);
  }
}